class ContactFilter extends HTMLElement {
  connectedCallback() {
    const buttonsContainer = this.querySelector('#filters');
    const contactsContainer = this.querySelector('.contacts-list');

    if (!buttonsContainer || !contactsContainer) return;

    const buttons = buttonsContainer.querySelectorAll('.filter-button');
    const contacts = contactsContainer.querySelectorAll('.contacts-item');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const location = button.getAttribute('data-location');

        buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        contacts.forEach(emp => {
          const empLocs = emp.getAttribute('data-location').split(',').map(l => l.trim());
          if (location === 'all' || empLocs.includes(location)) {
            emp.style.display = 'flex';
          } else {
            emp.style.display = 'none';
          }
        });
      });
    });
  }
}
  
customElements.define('contact-filter', ContactFilter);